import React from "react"
import {MovieEdit} from "components/backoffice/Media/Movie/MovieEdit"

export const MovieEditRoute = (props: any) => {

  return <div>
    <MovieEdit id={""} />
  </div>
}